/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailParamsProcessReminderCustomerTemplateData } from '../../models/mail-params-process-reminder-customer-template-data';
import { ResponseObject } from '../../models/response-object';

export interface SendProcessReminderCustomerMail$Params {
      body: MailParamsProcessReminderCustomerTemplateData
}

export function sendProcessReminderCustomerMail(http: HttpClient, rootUrl: string, params: SendProcessReminderCustomerMail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseObject>> {
  const rb = new RequestBuilder(rootUrl, sendProcessReminderCustomerMail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseObject>;
    })
  );
}

sendProcessReminderCustomerMail.PATH = '/sendMail/process-reminder-customer';
